/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import {
  Card,
  Switch,
  Row,
  Col,
  Input,
  Typography,
  Checkbox,
  Form,
} from "antd";
import creditPreview from "../../../assests/images/creditPreview.png";
import "./style.scss";
import { WarningOutlined } from "@ant-design/icons";
import contact from "../../../assests/images/settings/contact.svg";
import NotiIcon from "../../../assests/images/settings/noti.svg";
import bulkIcon from "../../../assests/images/settings/bullkfilledicon.svg";
import creditIcon from "../../../assests/images/settings/creditfilledicon.svg";
import settingBox from "../../../assests/images/settings/shipBox.svg";
import customiseForm from "../../../assests/images/settings/pPolicy.svg";
import nextArrow from "../../../assests/images/settings/NextArrow.svg";

const { Title, Text } = Typography;

const orderStages = [
  "Packed",
  "Shipped",
  "Reached at Destination",
  "Out for Delivery",
  "Arriving Early",
  "Delivery Delayed",
  "Delivered",
  "Picked Up",
];

const notificationTypes = [
  "Mobile push notification",
  "Desktop Notification",
  "Email Notification",
];

const sidebarMenu = [
  { key: "feature", label: "Credit booking", icon: creditIcon },
  { key: "security", label: "Cash booking", icon: contact },
  { key: "profile", label: "Bulk booking", icon: bulkIcon },
];

const getInitialSwitchState = () => {
  const state = {};
  notificationTypes.forEach((type) => {
    state[type] = {};
    orderStages.forEach((stage) => {
      // Email Notification's Shipped is off by default, others on
      state[type][stage] = !(
        type === "Email Notification" && stage === "Shipped"
      );
    });
  });
  return state;
};

const NotificationSettings = () => {
  const [switchState, setSwitchState] = useState(getInitialSwitchState());

  const handleSwitchChange = (type, stage, checked) => {
    setSwitchState((prev) => ({
      ...prev,
      [type]: {
        ...prev[type],
        [stage]: checked,
      },
    }));
  };

  return (
    <div
      style={{
        marginBottom: 24,
        border: "1px solid #e5e5e5",
        borderRadius: 10,
        padding: 30,
      }}
      className="notification-container"
    >
      <div className="d-flex settings-headers">
        <div className="settings-headers-img">
          <img src={NotiIcon} alt="Notification" />
        </div>
        <div>
          <h4>Notification</h4>
          <p>Manage your notifications</p>
        </div>
      </div>

      <Row gutter={24} style={{ marginTop: 24 }}>
        {notificationTypes.map((type) => (
          <Col span={8} key={type}>
            <div
              style={{
                marginBottom: 16,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div style={{ height: 70 }}>
                <Text strong>{type}</Text>
                <br />
                <span
                  style={{
                    fontSize: 12,
                    lineHeight: 0,
                    padding: 0,
                    margin: 0,
                    color: "#585B5F",
                  }}
                >
                  Receive {type} notification whenever your? organisation
                  requires your attentions
                </span>
              </div>
              <Switch defaultChecked={type !== "Email Notification"} />
            </div>
            <div>
              {orderStages.map((stage) => (
                <div
                  key={stage}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    borderRadius: 2,
                    padding: "8px 8px",
                    border: "1px solid #e5e5e5",
                    background: switchState[type][stage]
                      ? "#e6f7ff"
                      : "transparent",
                    transition: "background 0.2s",
                  }}
                >
                  <Text>{stage}</Text>
                  <Switch
                    checked={switchState[type][stage]}
                    onChange={(checked) =>
                      handleSwitchChange(type, stage, checked)
                    }
                  />
                </div>
              ))}
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
};

const ShipmentSettings = () => {
  const [form] = Form.useForm();

  const onFinish = (values) => {
    console.log("Form values:", values);
  };

  return (
    <div className="shipment-card">
      <div className="d-flex settings-headers">
        <div className="settings-headers-img">
          <img src={settingBox} alt="settingBox" />
        </div>
        <div>
          <h4>Shipment Setting</h4>
          <p>Manage shipment settings</p>
        </div>
      </div>
      <Text></Text>
      <Form form={form} onFinish={onFinish} layout="vertical">
        <Row gutter={16} className="shipment-row">
          <Col span={6}>
            <Form.Item
              name="cashDiscount"
              label={
                <Text className="shipment-input-label">Cash Discount</Text>
              }
            >
              <Input placeholder="Enter cash discount" type="number" />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              name="insuranceCharges"
              label={
                <Text className="shipment-input-label">Insurance Charges</Text>
              }
            >
              <Input placeholder="Enter charges" type="number" />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item
              name="doxWeightMin"
              label={
                <Text className="shipment-input-label">Weight for Dox</Text>
              }
            >
              <Input
                placeholder="Min"
                className="shipment-input"
                type="number"
              />
            </Form.Item>
          </Col>
          <Col span={2} className="shipment-input-child">
            <Form.Item name="doxWeightMax">
              <Input
                placeholder="Max"
                className="shipment-input"
                type="number"
              />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item
              name="nonDoxWeightMin"
              label={
                <Text className="shipment-input-label">Weight for Non-Dox</Text>
              }
            >
              <Input
                placeholder="Min"
                className="shipment-input"
                type="number"
              />
            </Form.Item>
          </Col>
          <Col span={2} className="shipment-input-child">
            <Form.Item name="nonDoxWeightMax">
              <Input
                placeholder="Max"
                className="shipment-input"
                type="number"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16} className="shipment-row-bottom">
          <Col span={6}>
            <Form.Item
              name="fovCharges"
              label={<Text className="shipment-input-label">FOV Charges</Text>}
            >
              <Input placeholder="Enter charges" type="number" />
            </Form.Item>
          </Col>
          <Col span={18} className="shipment-switches">
            <div>
              <Switch defaultChecked /> Document Series
            </div>
            <div>
              <Switch /> Auto Sense On
            </div>
            <div>
              <Switch defaultChecked /> Show Total
            </div>
            <div>
              <Switch /> Is Show Receipt
            </div>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

const CustomiseFormSettings = () => {
  return (
    <Card
      style={{ marginBottom: 24, borderRadius: 10, padding: 30 }}
      className="customise-form-card"
    >
      <div className="d-flex settings-headers">
        <div className="settings-headers-img">
          <img src={customiseForm} alt="customiseForm" />
        </div>
        <div>
          <h4>Customise Booking Form</h4>
          <p>
            Choose and include additional fields in the order creation form to
            customize it as per your needs
          </p>
        </div>
      </div>
      <div
        style={{
          background: "#f4f4f4",
          margin: "16px 0px",
          padding: "6px 10px",
          borderRadius: 10,
        }}
      >
        <div>
          <WarningOutlined />
          Fields that you select below will be added and shown in the domestic
          single order form for you to capture more details.
        </div>
      </div>
      <Row gutter={24}>
        <Col span={8}>
          <Title level={5} style={{ marginBottom: 8, fontSize: 16 }}>
            Select Input field that you need
          </Title>
          <div style={{ marginBottom: 16 }}>
            <Text strong>Sender Details</Text>
            <Checkbox.Group
              style={{ display: "flex", flexDirection: "column", marginTop: 8 }}
              defaultValue={["Client", "Department", "Type", "Service Type"]}
            >
              <Checkbox value="Client">Client</Checkbox>
              <Checkbox value="Department">Department</Checkbox>
              <Checkbox value="Type">Type</Checkbox>
              <Checkbox value="Service Type">Service Type</Checkbox>
            </Checkbox.Group>
          </div>
          <div style={{ marginBottom: 16 }}>
            <Text strong>Receiver Details</Text>
            <Checkbox.Group
              style={{ display: "flex", flexDirection: "column", marginTop: 8 }}
              defaultValue={["Mobile Number"]}
            >
              <Checkbox value="Mobile Number">Mobile Number</Checkbox>
              <Checkbox value="Email">Email</Checkbox>
              <Checkbox value="Receiver name">Receiver name</Checkbox>
            </Checkbox.Group>
          </div>
          <div>
            <Text strong>Service & Shipment Details</Text>
            <Checkbox.Group
              style={{ display: "flex", flexDirection: "column", marginTop: 8 }}
            >
              <Checkbox value="Insurance">Insurance</Checkbox>
              <Checkbox value="e-Way Bill">e-Way Bill</Checkbox>
              <Checkbox value="Content">Content</Checkbox>
            </Checkbox.Group>
          </div>
        </Col>
        <Col span={16}>
          <Title level={5} style={{ marginBottom: 8, fontSize: 16 }}>
            Add Order Preview
          </Title>
          <div
            style={{
              border: "1px solid #e5e5e5",
              borderRadius: 8,
              padding: 16,
              background: "#f9f9f9",
              minHeight: 400,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {/* Replace the src below with your actual image path */}
            <img
              src={creditPreview}
              alt="Order Preview"
              style={{ maxWidth: "100%", maxHeight: 380, objectFit: "contain" }}
            />
          </div>
        </Col>
      </Row>
    </Card>
  );
};

const FeatureFlag = () => {
  const [activeMenu, setActiveMenu] = useState("feature");

  return (
    <div className="feature-flag-layout">
      <div className="settings-sidebar">
        <ul className="sidebar-menu">
          {sidebarMenu.map((item) => (
            <>
              <li
                key={item.key}
                className={activeMenu === item.key ? "sidebar-active" : ""}
                onClick={() => setActiveMenu(item.key)}
              >
                <img src={item.icon} alt={item.label} />

                {item.label}
                <img
                  style={{ marginLeft: 35, width: 20, height: 20 }}
                  src={nextArrow}
                  alt={item.label}
                />
              </li>
            </>
          ))}
        </ul>
      </div>
      <div className="feature-flag-container">
        <NotificationSettings />
        <ShipmentSettings />
        <CustomiseFormSettings />
      </div>
    </div>
  );
};

export default FeatureFlag;
